import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'app-split-button',
  templateUrl: './split-button.component.html',
  styleUrls: ['./split-button.component.scss'],
})
export class SplitButtonComponent implements AfterViewInit {
  @Input() value: string = '';
  @Input() disabled = false;
  @Input() textColor = '';
  @Input() paddingSize: number = 0;
  @Input() hideClose = false;
  paddingStyle = {};
  display = false;
  @Input() options: string[] = [];
  @Output() optionSelect = new EventEmitter();

  constructor(private _elementRef: ElementRef) {}

  ngAfterViewInit() {
    if (this.paddingSize) {
      this.paddingStyle = {
        padding: `${this.paddingSize}px`,
      };
    }
  }

  toggle() {
    this.display = !this.display;
  }

  @HostListener('document:click', ['$event'])
  checkExternalClick($event: Event) {
    if (this._elementRef.nativeElement.contains($event.target) && !this.disabled) {
      this.toggle();
    } else {
      this.display = false;
    }
  }

  select(selectedOption: any) {
    this.optionSelect.emit(selectedOption);
  }
}
